<template>
    <div id="opnDetail">
        <bread :content="breadContent"></bread>
        <p class="Page-title">观点摘要</p>
        <el-divider></el-divider>
        <div id="content">
            <blockTime :year="time.year" :month="time.month" :day="time.day"></blockTime>
            <p id="title">{{viewData.Title}}</p>
            <p>专家姓名：{{viewData.Name}}</p>
            <p v-if="viewData.Position">现任职务：{{viewData.Position}}</p>
            <p v-if="viewData.ResearchDirection">从事方向：{{viewData.ResearchDirection}}</p>
            <p>讲座观点：{{viewData.View}}</p>
        </div>
    </div>
</template>
<script>
import bread from "@/components/bread"
import blockTime from '@/components/blockTime'
import Api from '@/network.js'
import utils from '@/utils.js'

export default {
  name: "opnDetail",
  components: {
    bread,
    blockTime
  },
  async beforeRouteEnter (to, from, next) {
    const data = {}
    data.viewData = await Api.academic.getOpinionContent(to.query.id)
    data.time = utils.timeResult(data.viewData.AdminSetTime)
    next(vm => {
      vm.setData(data)
      // 指定高亮菜单栏文字
      vm.$store.commit('setHighlightText', "观点摘要")
    })
  },
  data() {
    return {
      breadContent: [
        { text: "首页", routerName: "index" },
        { text: "学术交流", routerName: "academic" },
        { text: "观点摘要", routerName: "opinion" }
      ],
      viewData: {},
      time:{}
    };
  },
  methods: {
    setData(data) {
      Object.assign(this.$data, data)
    }
  },
  // 离开详情页时清除侧边栏高亮项，防止冲突
  destroyed() {
    this.$store.commit('setHighlightText', '')
  }
};
</script>
<style lang="scss" scoped>
#opnDetail {
  width: calc(100% - 250px);
  margin-left: 50px;
  margin-top: 40px;
}
#content {
    position: relative;
    font-size: 18px;
    text-align: justify;
    text-justify: inter-word;
    line-height: 32px;
    padding-right: 5%;
  #title {
    text-align: center;
    padding:25px 75px;
    font-weight: 400;
    font-size: 24px;
    margin-top: 15px;
    margin-bottom:20px;
  }
  .blockTime {
    position: absolute;
    left: 0;
    top: -10px;
  }
}
</style>
